export const PARTICIPANT_LIMIT_ERROR_CODE = 'PARTICIPANT_LIMIT_REACHED'

const PORTAL_REGISTRATION_SUCCESS = Object.freeze({
  lite: {
    titleKey: 'lite_registration_success_title',
    emailTextKey: 'lite_registration_success_email_text',
    fallbackTextKey: 'lite_registration_success_text',
    actionKey: 'lite_registration_success_action',
    loginPath: '/mvu-lite/login',
  },
  accelerator: {
    titleKey: 'accelerator_registration_success_title',
    emailTextKey: 'accelerator_registration_success_email_text',
    fallbackTextKey: 'accelerator_registration_success_text',
    actionKey: 'accelerator_registration_success_action',
    loginPath: '/mvu-accelerator/login',
  },
})

export const isParticipantLimitError = result => (
  result?.error?.details?.code === PARTICIPANT_LIMIT_ERROR_CODE
  || /maximum number of participants|maximum number of uses/i.test(result?.error?.message || '')
)

export const getPortalRegistrationSuccess = (context, result) => {
  const config = PORTAL_REGISTRATION_SUCCESS[context]
  if (!config) return null

  return {
    ...config,
    textKey: result?.registration?.welcome_email_sent === true
      ? config.emailTextKey
      : config.fallbackTextKey,
  }
}
